import { PropsWithChildren } from 'react';
import { EntitiesType } from './types';
import { cssVar, VStack } from '@cad-arc';
import { UseFormReturn } from 'react-hook-form';
import { FrCreateOrEditEventFormSectionTitle } from '../fr-create-or-edit-event-page/fr-create-or-edit-event-form-section-title';
import { NoMembersIndicator } from '../event-panel/tabs/components/no-members-indicator';
import { PropertyBaseKey } from '../event-panel/event-panel-form/involved-person-vehicle-fields/types';
import { FormInputButton } from '../forms/integrated-form-components/form-button';
import { useIsClearedEvent } from '../event-panel/event-panel-form/use-is-cleared-event';
import { EventPanelFormType } from '@mark43/cad-api';
import { useAddDrugsToForm, useAddFirearmToForm, useAddOtherItemsToForm } from './hooks';
import { useTrackedFieldArray } from '../forms/use-tracked-field-array';

export function FrAddEventPropertyPropertiesWrapper({
    children,
    entitiesType,
    noEntities,
    allowMembersControl,
    form,
    propertyText = '',
    noMembersText = '',
}: PropsWithChildren<{
    entitiesType: EntitiesType;
    noEntities: boolean;
    propertyText?: string;
    noMembersText?: string;
    allowMembersControl: boolean;
    form: UseFormReturn<EventPanelFormType>;
}>) {
    const isClearedEvent = useIsClearedEvent();
    const noMemberIcon = entitiesType === 'firearms' ? 'Firearm' : 'Property';
    const addFirearmToForm = useAddFirearmToForm();
    const addDrugsToForm = useAddDrugsToForm();
    const addOtherItemToForm = useAddOtherItemsToForm();

    const { fields } = useTrackedFieldArray({
        control: form.control,
        name: entitiesType as PropertyBaseKey,
        keyName: 'rhfKey',
    });

    const appendItem = () => {
        if (entitiesType === 'firearms') {
            addFirearmToForm('firearms');
        } else if (entitiesType === 'drugs') {
            addDrugsToForm('drugs');
        } else if (entitiesType === 'otherItems') {
            addOtherItemToForm('otherItems');
        }
    };

    const addText = propertyText.slice(0, propertyText.length - 1);
    const headerTitle = entitiesType === 'otherItems' ? 'Other' : entitiesType;

    const addPropertyButton = allowMembersControl && !isClearedEvent && (
        <FormInputButton
            size="md"
            variant="ghost"
            leadingVisual="Add"
            data-testid={`add-${entitiesType}-button`}
            onClick={appendItem}
        >
            Add {addText}
        </FormInputButton>
    );
    return (
        <VStack
            overflowY="auto"
            h="100%"
            w="33%"
            gap="5px"
            alignItems="flex-start"
            paddingTop={cssVar('arc.space.6')}
        >
            <FrCreateOrEditEventFormSectionTitle title={headerTitle} />
            <VStack
                w="100%"
                h="100%"
                alignItems="flex-start"
                overflowY="auto"
                padding={0}
                margin={0}
            >
                {noEntities ? (
                    <VStack
                        w="100%"
                        h="100%"
                        alignItems="center"
                        overflowY="auto"
                        padding={0}
                        margin={0}
                        flexDirection="row"
                    >
                        <NoMembersIndicator
                            text={noMembersText}
                            icon={noMemberIcon}
                            value={fields}
                            action={addPropertyButton}
                        />
                    </VStack>
                ) : (
                    children
                )}
            </VStack>
        </VStack>
    );
}
